import { freezeSys, toPlainObject } from 'contentful-sdk-core';
import enhanceWithMethods from '../enhance-with-methods';
import cloneDeep from 'lodash/cloneDeep';
/**
 * @memberof User
 * @typedef User
 * @prop {Object} sys - System metadata
 * @prop {string} sys.id - User id
 * @prop {string} sys.type - Entity type
 * @prop {string} firstName - User first name
 * @prop {string} lastName - User last name
 * @prop {string} avatarUrl - User avatar url
 * @prop {string} email - User email
 * @prop {boolean} activated - User activated
 * @prop {number} signInCount - User sign in count
 * @prop {boolean} confirmed - User confirmed
 * @prop {function(): Object} toPlainObject() - Returns this User as a plain JS object
 */

/*
 *
 * @private
 * */
export function wrapUser(http, data) {
  var user = toPlainObject(cloneDeep(data));
  enhanceWithMethods(user, {});
  return freezeSys(user);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/contentful-management/dist/es-modules/entities/user.js
// module id = 204
// module chunks = 0